/**
 * Malaysia school data source
 * Structure (real data): STATE_KEY -> SCHOOL_TYPE_KEY -> SCHOOL_NAME[]
 *
 * Data is loaded from school_dropdown.json at runtime.
 */
var malaysiaSchoolData = {};

/**
 * Optional aliases from region API state names -> JSON keys.
 */
var malaysiaStateKeyAliases = {
  "KUALA LUMPUR": "WILAYAH PERSEKUTUAN KU",
  "LABUAN": "WILAYAH PERSEKUTUAN LA",
  "PUTRAJAYA": "WILAYAH PERSEKUTUAN PU",
  "PENANG": "PULAU PINANG",
  "PULAU PINANG": "PULAU PINANG",
  "MALACCA": "MELAKA"
};

function normalizeMalaysiaStateName(name) {
  if (!name) return "";
  return String(name)
    .toUpperCase()
    .replace(/\./g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function getMalaysiaStateKey(stateName) {
  var normalized = normalizeMalaysiaStateName(stateName);
  if (!normalized) return "";
  if (malaysiaSchoolData[normalized]) return normalized;
  if (malaysiaStateKeyAliases[normalized]) return malaysiaStateKeyAliases[normalized];
  return "";
}

function getMalaysiaSchoolsByType(stateName, schoolTypeKey) {
  var stateKey = getMalaysiaStateKey(stateName);
  if (!stateKey || !schoolTypeKey) return [];
  var stateData = malaysiaSchoolData[stateKey];
  if (!stateData) return [];
  return stateData[schoolTypeKey] || [];
}

/**
 * School type numeric ID (matches option values in #shcooletype) -> data key mapping
 */
var schoolTypeIdToKey = {
  "1": "SK",
  "2": "SJKC",
  "3": "SJKT",
  "5": "SK KHAS",
  "6": "SR SABK",
  "7": "K9",
};
